var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceipt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378 371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.9 370.9H66.7c-18-.6-34.8-8.1-47.3-21.1C6.9 336.8 0 319.7 0 301.7v-33c0-10 8.1-18.1 18.1-18.1h42V44.3c0-7.8 2.8-15.4 8.1-21.2 5.6-6.3 13.4-10 21.9-10.5 8.5-.5 16.6 2.4 22.9 8l12.3 10.9 25.9-23.1c12-10.8 30.2-10.8 42.2 0l25.9 23.1 25.9-23.1c12-10.8 30.2-10.8 42.2 0l25.9 23.1 12.4-10.9c9.2-8.3 22.5-10.4 33.8-5.3 11.2 5 18.5 16.2 18.5 28.6v257.8c.1 38.1-30.9 69.2-69.1 69.2zM67.1 354.3h241.8c29 0 52.7-23.6 52.7-52.7V43.8c0-5.8-3.4-11.1-8.7-13.5h-.1c-5.3-2.4-11.6-1.4-15.9 2.5l-.1.1-23.4 20.6-36.9-32.9c-5.8-5.2-14.5-5.2-20.2 0l-36.9 32.9-36.9-32.9c-5.8-5.2-14.5-5.2-20.2 0l-36.9 32.9L102 32.9c-3.1-2.7-7-4.1-11-3.9-4 .2-7.7 2-10.4 5-2.5 2.8-3.9 6.4-3.9 10.2V267H18.1c-.9 0-1.6.7-1.6 1.6v33c0 13.7 5.2 26.7 14.8 36.6 9.5 9.9 22.2 15.6 35.8 16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.6 130.7H130.3c-5.7 0-10.3-4.6-10.3-10.3 0-5.7 4.6-10.3 10.3-10.3h101.3c5.7 0 10.3 4.6 10.3 10.3 0 5.7-4.6 10.3-10.3 10.3zM307.3 208h-177c-5.7 0-10.3-4.6-10.3-10.3 0-5.7 4.6-10.3 10.3-10.3h177c5.7 0 10.3 4.6 10.3 10.3 0 5.7-4.6 10.3-10.3 10.3zM272.4 370.5c-33.3-15.5-49-38.9-56.3-55.7-8.1-18.8-9.1-36.8-7.4-47.7H42.4v-16.5h169.1c4.4 0 8.4 2 11.1 5.4 2.7 3.4 3.7 7.8 2.7 12-2.7 11.9-1.5 61.7 54 87.6l-6.9 14.9z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.059f292e.svg";
export { ForwardRef as ReactComponent };